<!-- Search Builder -->

<template>
	<div class="bld-search-main">
		<div class="title wi8_font">Search Builder</div>
		<div class="label">Category:</div><div class="label">{{search.cat.itemId}}</div>
		<div class="label">Keyword:</div><div class="label">{{search.keyword}}</div>
		<div />
		<div class="label">Date Beg:</div><div class="label">{{search.dateBeg}}</div>
		<div class="label">Date End:</div><div class="label">{{search.dateEnd}}</div>
		<div />
		<div class="label">Page:</div><div class="label">{{pager.curPage}}</div>
		<div class="label">View:</div><div class="label">{{view}}</div>

		<br/><br/>

		<Search />

	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	data() {
		return {
			view: "err",
		}
	},
	computed: {
		...mapState('app', ['search', 'pager', 'role']),
		...mapState('api', ['source']),
	},
	methods: {
		calcImgUrl(itype, file_name) {
			return this.source.url + this.source.ico + 'cat/' + itype + '/' + file_name;
		},
	},
	created() {
		this.view = (this.role=="adm")? "full": "";
	},
}
</script>

<style scoped>
.bld-search-main {
	height: 100%;
	overflow: hidden;
	background-color: #FCFCEE;
	padding: 5px;
	border: solid 1px #009;
}

.title {
	color: #F60;
}

.label {
	display: inline-block;
	width: 75px;
	height: 22px;
	overflow: hidden;
	vertical-align: top;
	border: solid 0px #369;
}


</style>
